<template>
    <v-dialog v-model="dialog" width="500">
        <v-card>
            <v-card-title class="subtitle-2" primary-title>
                {{ this.$t('customer.index.information.erp-data.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="py-4">
                <template>
                    <v-simple-table v-if="this.dialog">
                        <template v-slot:default>
                            <tr>
                                <th>
                                    {{
                                        $t(
                                            'customer.index.information.erp-data.login-code',
                                        )
                                    }}
                                </th>
                                <td>
                                    {{ erpData.login_code || null }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {{
                                        $t(
                                            'customer.index.information.erp-data.username',
                                        )
                                    }}
                                </th>
                                <td>
                                    {{ erpData.username || null }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {{
                                        $t(
                                            'customer.index.information.erp-data.password',
                                        )
                                    }}
                                </th>
                                <td>
                                    {{ erpData.password || null }}
                                </td>
                            </tr>
                        </template>
                    </v-simple-table>
                </template>
            </v-card-text>
            <v-card-text class="pb-2">
                <v-alert text type="info" border="left">
                    {{ $t('customer.index.information.erp-data.information') }}
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue" text @click="dialog = false">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            erpData: null,
        }
    },

    methods: {
        open(erpData) {
            this.erpData = erpData
            this.dialog = true
        },
    },
}
</script>

<style></style>
